const React = require('react');
const createReactClass = require('create-react-class');
const _ = require('lodash');
const assign = require('object-assign');
const FuzzyReaction = require('../../bootstrap').FuzzyReaction;
const Table = FuzzyReaction.Components.Visualization.Tables.Table;
const Paginator = FuzzyReaction.Components.Visualization.Pagination.PaginatedButtons;
const PerPageSelector = FuzzyReaction.Components.Visualization.Pagination.PerPageSelector;
const PageSearch = FuzzyReaction.Components.Visualization.PageSearch;
const Modal = FuzzyReaction.Components.Global.Modal;
const Column = FuzzyReaction.Components.PageStructure.Column;
const Row = FuzzyReaction.Components.PageStructure.Row;
const ResourceActions = FuzzyReaction.Actions.ResourceActions;
const WorkoutsStore = require('../../stores/WorkoutsStore');
const Form = FuzzyReaction.Components.ResourceBinding.Form.Form;
const CastManagementMixin = require('../cast-library/components/CastManagementMixin');

const Workouts = createReactClass({
    displayName: 'Workouts',
    mixins: [CastManagementMixin],

    /**
     * Resource actions set up
     */
    resourceActions: new ResourceActions('workouts'),

    formKey: "editWorkout",

    getInitialState: function () {
        return {
            openDeleteModal: false,
            openEditModal: false,
            currentPageData: [],
            workingResource: {},
        }
    },

    /**
     * Resource action options
     */
    getOptions: {
        modifiers: {
            filters: {
                user_id: 'NOT_NULL'
            },
            sort: {
                id: 'desc'
            },
            pagination: {
                per_page: '50'
            },
        },
        dataNode: 'data',
        refresh: 'list'
    },

    /**
     * Fire an action to request data from the API
     */
    requestTableData: function (modifiers) {
        // Merge modifiers with already present ones
        this.getOptions.modifiers = assign(this.getOptions.modifiers, modifiers, {});

        this.resourceActions.listResource(this.getOptions);
    },

    /**
     * Register event listeners and fire request for data
     */
    componentDidMount: function () {
        if (this.props.location.query && this.props.location.query.user_id) {
            this.getOptions.modifiers.filters.user_id = '=' + this.props.location.query.user_id;
        }
        this.requestTableData();
        this.changeListener = this._onChange;
        WorkoutsStore.addChangeListener(this.changeListener);
    },

    /**
     * Deregister an event listener
     */
    componentWillUnmount: function () {
        WorkoutsStore.removeChangeListener(this.changeListener);
    },

    /**
     * Handle changes in data and request paginated data
     *
     * @private
     */
    _onChange: function () {
        this.setState({
            currentPageData: WorkoutsStore.getResourceListData()
        });
    },

    /**
     * @param action
     * @param resource
     */
    handleAction: function (action, resource) {
        switch (action) {
            case 'sort':
                this.requestTableData(resource);
                break;
            case 'edit':
                this.setState({
                    openEditModal: true,
                    workingResource: {
                        id: resource.id,
                        user_id: resource.user_id,
                        created_at: resource.created_at,
                        duration: resource.duration,
                        calories: null,
                        miles_biked: null,
                        is_complete: 1
                    }
                });
                break;
            case 'delete':
                this.setState({
                    openDeleteModal: true,
                    workingResource: {id: resource.id},
                });
                break;
        }
    },

    /**
     * Fire the save workout action
     */
    saveWorkout: function () {
        this.resourceActions.updateResource(this.state.workingResource, this.getOptions);
    },

    /**
     * Fire the delete workout action
     */
    deleteWorkout: function () {
        this.resourceActions.deactivateResource(this.state.workingResource, this.getOptions);
    },

    /**
     * Close all modals and reset the working resource
     */
    closeModal: function () {
        this.setState({
            openDeleteModal: false,
            openEditModal: false,
            workingResource: {}
        });
    },

    tableKeys: {
        'ID': 'id',
        'Created': 'created_at',
        'Updated': 'updated_at',
        'User Updated': 'user_updated_at',
        'User ID': 'user_id',
        'Cast ID': 'cast_id',
        'Format-Modality': 'format_modality_label',
        'Heart Rate': 'heart_rate',
        'User Heart Rate': 'user_heart_rate',
        'Calories': 'calories',
        'User Calories': 'user_calories',
        'Distance (mi)': 'miles_biked',
        'User Distance (mi)': 'user_miles_biked',
        'Complete?': 'is_complete',
        'Duration': 'duration',
        'User Notes': 'user_notes'
    },

    render: function () {
        const toMinutesString = this.toMinutesString;

        const tableOptions = {
            actionableRows: true,
            actions: ['delete:danger', 'edit:primary'],
            actionsCallback: this.handleAction,
            mutators: {
                duration: function (duration) {
                    return toMinutesString(duration);
                },
                completed: function (value) {
                    return value === 1 ? 'Yes' : 'No';
                }
            },
            sortable: ['id', 'created_at', 'updated_at', 'user_updated_at', 'user_id', 'cast_id', 'format_modality_label', 'heart_rate', 'user_heart_rate', 'calories', 'user_calories', 'miles_biked', 'user_miles_biked', 'is_complete', 'duration', 'user_notes'],
            emptyText: 'No workouts found.',
            hideSpinner: true
        };

        return (
            <div id="page-wrapper">
                <div id="page-content">
                    <div id="content"/>
                    <Row classes="align-items-center">
                        <Column grid="lg" size="8">
                            <h1 className="page-header">Workouts</h1>
                        </Column>

                        <Column grid="lg" size="4">
                            <div className="page-header">
                                <PageSearch actionMethod={this.requestTableData}
                                            searchable={['id', 'created_at', 'updated_at', 'cast_id', 'user_id', 'user_notes']}/>
                            </div>
                        </Column>
                    </Row>

                    <Row>
                        <Column grid="lg" size="12">
                            <Table data={this.state.currentPageData}
                                   dataKeys={this.tableKeys}
                                   title={'Workouts'} options={tableOptions}/>
                        </Column>
                    </Row>
                    <Row>
                        <Paginator actionMethod={this.requestTableData}/>
                        <PerPageSelector actionMethod={this.requestTableData}/>
                    </Row>
                </div>

                <Modal openWhen={this.state.openDeleteModal}
                       title="Delete Workout?" closeText="Close"
                       saveText="Delete" afterClose={this.closeModal}
                       beforeSave={this.deleteWorkout}
                       afterSave={this.closeModal}>
                    <p>You’re about to delete this user's workout. It will also delete any feedback the user left for
                        this workout.</p>
                    <p><strong><span style={{color: 'red'}}>THIS IS PERMANENT.</span></strong> There's no going back!
                    </p>
                    <p>Continue with deleting this workout and associated feedback?</p>
                </Modal>

                <Modal openWhen={this.state.openEditModal} options={{width: '30%'}}
                       title={'Edit and Recalculate Workout'} closeText="Close"
                       saveText="Save and Recalculate" afterClose={this.closeModal}
                       beforeSave={this.saveWorkout}
                       afterSave={this.closeModal}>
                    <Column grid="lg" size="12">
                        <div className="workout-modal-body">
                            <p>You’re about to edit this user's workout duration. When saving, the workout will be
                                marked complete and the distance and calories will be recalculated. If you leave
                                duration blank, the workout duration will equal the duration of the cast.</p>
                            <p>
                                <strong>Workout ID:</strong> {this.state.workingResource.id}
                            </p>
                            <p>
                                <strong>User ID:</strong> {this.state.workingResource.user_id}
                            </p>
                            <p>
                                <strong>Workout Date:</strong> {this.state.workingResource.created_at}
                            </p>
                            <Form key={this.formKey + this.state.workingResource.id} formKey={this.formKey}
                                  bindResource={this.state.workingResource}>

                                <Form.Input fieldKey="duration" type="number" label="Duration:"
                                            placeholder="duration in seconds"
                                            limit={7}/>
                            </Form>
                        </div>
                    </Column>
                </Modal>
            </div>
        )
    },
});

module.exports = Workouts;
